import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { DocumentsService, LoginService } from '@pxl/models/contracts';
import { DocumentService as BackendDocumentsService } from '@pxl/shared/generated';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultDocumentService implements DocumentsService {
    private readonly API_VERSION = inject(CONFIG_TOKEN).API_VERSION;
    private readonly loginService = inject(LoginService);
    private readonly documentsService = inject(BackendDocumentsService);

    public downloadDocument(id: string): Observable<string> {
        return this.documentsService.downloadDocument(id, this.API_VERSION, this.loginService.getToken());
    }
}
